// replace the user pool region, id, and app client id details
export default {
    "REGION": "us-west-2",
    "USER_POOL_ID": "us-west-2_Sq10a2kq3",
    "USER_POOL_APP_CLIENT_ID": "1ikhj5gff40imsu2kg875qf5m1",
    "REQUIRED_ATTRIBUITES": [
        "email",
        "first_name"
        ]
}